import React, { useState, useCallback, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { useRecoilValue } from 'recoil'

import { Select } from 'mailup-web-components'
import './ColumnsManager.scss'

import {
  manageableFieldsState,
  visibleColumnsState
} from 'Pages/AbTestWizard/recoil/state/abtest'

const COLUMNS_MAX_LENGTH = 5

export const ColumnsManager = ({ onChange }) => {
  const intl = useIntl()
  const manageableFields = useRecoilValue(manageableFieldsState)
  const columnsToShow = useRecoilValue(visibleColumnsState)

  const [selection, setSelection] = useState(columnsToShow)

  useEffect(() => {
    onChange(selection)
  }, [selection])

  const handleChangeSelect = value => {
    if (value) {
      setSelection(prev => prev.concat(value))
    }
  }

  const elMoved = useRef(null)

  const moveItem = useCallback(
    (el, indexDelta) => {
      if (elMoved.current) {
        elMoved.current.classList.remove('c-columns-manager__item--moved')
      }
      elMoved.current = el.parentElement
      if (elMoved.current) {
        elMoved.current.getBoundingClientRect() // force DOM reflow
        elMoved.current.classList.add('c-columns-manager__item--moved')
      }
      setSelection(prev => {
        const newValue = [...prev]
        const indexItem = prev.findIndex(value => value === el.value)
        const indexSwitch = Math.min(
          Math.max(indexItem + indexDelta, 0),
          selection.length - 1
        )

        newValue[indexItem] = prev[indexSwitch]
        newValue[indexSwitch] = prev[indexItem]

        return newValue
      })
    },
    [selection]
  )

  const handleClickMoveUp = e => {
    moveItem(e.currentTarget, -1)
  }
  const handleClickMoveDown = e => {
    moveItem(e.currentTarget, 1)
  }

  const handleClickRemove = e => {
    const { value } = e.target
    setSelection(prev => prev.filter(v => v !== value))
  }

  return (
    <div className='c-columns-manager'>
      {selection.length < COLUMNS_MAX_LENGTH && (
        <Select
          placeholder={intl.formatMessage({
            id: 'Load.SearchRecipients.SelectColumnPlaceholder'
          })}
          options={manageableFields
            .filter(({ id }) => !selection.includes(id))
            .map(({ id, description }) => ({
              value: id,
              label: description
            }))}
          onChange={handleChangeSelect}
        />
      )}
      <ul className='c-columns-manager__items'>
        {selection.map((id, i, { length }) => (
          <li
            className='c-columns-manager__item'
            key={`columns-manager-item-${id}`}
          >
            <button
              disabled={!i}
              value={id}
              className='c-columns-manager__control c-columns-manager__control--move c-columns-manager__control--move-up'
              onClick={handleClickMoveUp}
            />
            <button
              disabled={i === length - 1}
              value={id}
              className='c-columns-manager__control c-columns-manager__control--move c-columns-manager__control--move-down'
              onClick={handleClickMoveDown}
            />
            <span>
              {manageableFields.find(field => field.id === id).description}
            </span>
            <button
              disabled={length === 1}
              value={id}
              className='c-columns-manager__control c-columns-manager__control--remove'
              onClick={handleClickRemove}
            />
          </li>
        ))}
      </ul>
    </div>
  )
}

ColumnsManager.propTypes = {
  onChange: PropTypes.func
}
